export const VERTICAL_LAYOUT_MIN_WIDTH = 1000;
export const STICKY_FOOTER_LAYOUT_MIN_WIDTH = 600;
